const EmptyTable = () => {
  return <p>No hay datos</p>
}

export default EmptyTable
